import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Draggable from 'react-draggable';

import { handleChange, handleSubmit } from "../../Controller/CreateCustomerSiteController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CourierService from "../../../Setup/controller/CourierController/CourierController";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import Website from "../../../Common/website";
import SendEmail from "../../../Common/SendEmail";
function CreateCustomerSite({ site, onClose, onSuccess, CustomerID }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        BranchName: '', Address1: '', Address2: '', Address3: '', City: '',
        County: '', PostCode: '', Country: '0', Phone1: '', Phone2: '', Fax: '', CourierID: '', Website: '', Reference: '',
        Email: "", ClientCompanyID: CustomerID
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [CountryList, setCountries] = useState([]);
    const [CourierList, setCouriers] = useState([]);
    const [isMinimized, setIsMinimized] = useState(false);
    const [TitleList, setTitles] = useState([]);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const fetchCourier = async () => {
        try {
            const listOfCourier = await CourierService.GetAllCouriers();
            setCouriers(listOfCourier);
        } catch (error) {
            console.error('Error fetching couriers:', error);
        }
    };
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    useEffect(() => {
        if (site) {
            setFormData({
                BranchName: site.BranchName, Address1: site.Address1, Address2: site.Address2,
                Address3: site.Address3, City: site.City, County: site.County, PostCode: site.Postcode,
                Country: site.Country, Phone1: site.Phone1, Phone2: site.Phone2, Fax: site.Fax, CourierID: site.CourierID, Website: site.Website,
                Reference: site.Reference, ClientCompanyID: CustomerID, Forename: site.Forename,
                Surname: site.Surname, Title: site.Title, Email: site.Email
            });
        } else {
            setFormData({
                BranchName: '', Address1: '', Address2: '', Address3: '', City: '',
                County: '', PostCode: '', Country: '0', Phone1: '', Phone2: '', Fax: '', CourierID: '', Website: '', Reference: '',
                ClientCompanyID: CustomerID, Forename: '', Email: '',
                Surname: '', Title: 'Mr'
            });
        }
        fetchCountries();
        fetchCourier();
        fetchTitle();
    }, [site]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit =async (event) => {
        event.preventDefault();
        formData.ClientCompanyID = CustomerID;
        if (site) {
            formData.ClientBranchID = site.ClientBranchID;
        } else {
            formData.ClientBranchID = 0;
        }
        const redirectCallback = () => {
            navigate('/');
        };
        const redirectUserList = () => {
            navigate('/CustomerList?saved=true');
        };
       const response= await handleSubmit(event, formData, setFormData, setErrors);
        let CustomerSiteContact = localStorage.getItem('CustomerSiteContact');
        CustomerSiteContact = parseInt(CustomerSiteContact) + 1;
        localStorage.setItem('CustomerSiteContact', CustomerSiteContact);
        
        if(response.message==="Data saved successfully")
        {
            onSuccess(response.CustomerSiteID);
        }    
    };

    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerSitesModal show d-block" id="customerSitesModal" tabIndex="-1" aria-labelledby="customerSitesModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>

                            <div className="modal-content" style={{ height: '100%', width: '100%' }}>
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{site ? "Edit Site" : "Add Site"}</h5>


                                    <span>
                                        <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                            <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                        </button>

                                    </span>


                                </div>
                                {!isMinimized && (
                                    <>
                                        <div className="modal-body">
                                            <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                                                <table style={{ width: "100%" }}>
                                                    <tbody>


                                                        <tr>
                                                            <td style={{ width: "13%" }}><label htmlFor="inputText" style={{ float: "right" }}>Site Name <span style={{ "color": "red" }}>*</span></label></td>
                                                            <td style={{ width: "37%" }}>
                                                                <input type="text" className="form-control" name="BranchName" value={formData.BranchName} onChange={handleFieldChange} />
                                                                {errors.BranchName && <div style={{ color: 'red' }}>{errors.BranchName}</div>}
                                                            </td>
                                                            <td style={{ width: "13%" }}><label htmlFor="Title" style={{ float: "right" }}>Title &nbsp;&nbsp; </label></td>
                                                            <td style={{ width: "37%" }}>

                                                                <select name="Title" className='form-control' value={formData.Title} onChange={handleFieldChange}>
                                                                    <option value="0">Select Title</option>
                                                                    {TitleList.map((title) => (
                                                                        <option key={title.Title} value={title.Title}>
                                                                            {title.Title}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {errors.Title && <div style={{ color: 'red' }}>{errors.Title}</div>}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Address &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" placeholder={site ? '' : 'Address 1'} className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} />
                                                                {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                                            </td>

                                                            <td><label htmlFor="Forename" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="Forename" value={formData.Forename} onChange={handleFieldChange} />
                                                                {errors.Forename && <div style={{ color: 'red' }}>{errors.Forename}</div>}
                                                            </td>
                                                        </tr>


                                                        <tr>

                                                            <td><label htmlFor="inputText" style={{ float: "right" }}></label></td>
                                                            <td>
                                                                <input type="text" placeholder={site ? '' : 'Address 2'} className="form-control" name="Address2" value={formData.Address2} onChange={handleFieldChange} />
                                                                {errors.Address2 && <div style={{ color: 'red' }}>{errors.Address2}</div>}
                                                            </td>
                                                            <td><label htmlFor="Surname" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="Surname" value={formData.Surname} onChange={handleFieldChange} />
                                                                {errors.Surname && <div style={{ color: 'red' }}>{errors.Surname}</div>}
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td><label htmlFor="inputText" style={{ float: "right" }}></label></td>
                                                            <td>
                                                                <input type="text" placeholder={site ? '' : 'Address 3'} className="form-control" name="Address3" value={formData.Address3} onChange={handleFieldChange} />
                                                                {errors.Address3 && <div style={{ color: 'red' }}>{errors.Address3}</div>}
                                                            </td>


                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Phone &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <table style={{ width: "100%" }}>
                                                                    <tr>
                                                                        <td>
                                                                            <input type="text" placeholder={site ? '' : 'Phone 1'} className="form-control" name="Phone1" value={formData.Phone1} onChange={handleFieldChange} />
                                                                            {errors.Phone1 && <div style={{ color: 'red' }}>{errors.Phone1}</div>}
                                                                        </td>
                                                                        <td>
                                                                            {(site) && (formData.Phone1 != "" && formData.Phone1 != null && formData.Phone1 != "undefined") && (
                                                                                <a href={`tel:${formData.Phone1}`} onClick={(e) => e.stopPropagation()}>
                                                                                    <img src="assets/img/resources/phone.jpeg" class="" alt="Add icon" style={{ height: "22px" }} />
                                                                                </a>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </table>

                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>City &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="City" value={formData.City} onChange={handleFieldChange} />
                                                                {errors.City && <div style={{ color: 'red' }}>{errors.City}</div>}
                                                            </td>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Email &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <table style={{ width: "100%" }}>
                                                                    <tr>
                                                                        <td>
                                                                            <input type="text" className="form-control" name="Email" value={formData.Email} onChange={handleFieldChange} />
                                                                            {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}
                                                                        </td>
                                                                        <td>
                                                                            {site && (formData.Email != "" && formData.Email != null && formData.Email != "undefined") && (

                                                                                <a href='#' onClick={(event) => handleEmailClick(event, formData.Email)}>
                                                                                    <img src="assets/img/resources/email-icon.png" class="" alt="Add icon" style={{ height: "22px" }} />
                                                                                </a>
                                                                            )}
                                                                        </td>

                                                                    </tr>
                                                                </table>
                                                            </td>


                                                        </tr>

                                                        <tr>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>County &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="County" value={formData.County} onChange={handleFieldChange} />
                                                                {errors.County && <div style={{ color: 'red' }}>{errors.County}</div>}
                                                            </td>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Fax &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="Fax" value={formData.Fax} onChange={handleFieldChange} />
                                                                {errors.Fax && <div style={{ color: 'red' }}>{errors.Fax}</div>}
                                                            </td>

                                                        </tr>

                                                        <tr>

                                                            <td><label htmlFor="inputState" style={{ float: "right" }}>Country &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <select className="form-control" name="Country" value={formData.Country} onChange={handleFieldChange}>
                                                                    <option value="0">{t('Select Country')}</option>
                                                                    {CountryList.map(country => (
                                                                        <option key={country.PK_Country_ID} value={country.PK_Country_ID}>{country.vc_CountryName}</option>
                                                                    ))}
                                                                </select>
                                                                {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}
                                                            </td>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Website &nbsp;&nbsp;</label></td>
                                                            <table style={{ width: "100%" }}>
                                                                <tr>
                                                                    <td>
                                                                        <input type="text" className="form-control" name="Website" value={formData.Website} onChange={handleFieldChange} />
                                                                        {errors.Website && <div style={{ color: 'red' }}>{errors.Website}</div>}
                                                                    </td>
                                                                    <td>
                                                                        {site && (formData.Website != "" && formData.Website != null && formData.Website != "undefined") && (
                                                                            <Website webLink={formData.Website} />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </table>


                                                        </tr>
                                                        <tr>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>PostCode &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="PostCode" value={formData.PostCode} onChange={handleFieldChange} />
                                                                {errors.PostCode && <div style={{ color: 'red' }}>{errors.PostCode}</div>}
                                                            </td>
                                                            <td><label htmlFor="inputText" style={{ float: "right" }}>Reference &nbsp;&nbsp;</label></td>
                                                            <td>
                                                                <input type="text" className="form-control" name="Reference" value={formData.Reference} onChange={handleFieldChange} />
                                                                {errors.Reference && <div style={{ color: 'red' }}>{errors.Reference}</div>}
                                                            </td>

                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                        <div className="modal-footer" style={{ float: "right" }}>
                                            <button type="submit" className="btn btn-primary">
                                                <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {t('save')}
                                            </button>
                                            <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                                <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                            </button>
                                        </div>
                                    </>
                                )}

                            </div>

                        </Draggable>
                    </div>
                </div>
            </form>
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} />
            )}
        </div>
    );
}

export default CreateCustomerSite;
